import React, { useState, useEffect } from "react";
import Axios from "axios";
import { host } from "../App";
import "./UpholsteryEntry.css";
import { FitScreen } from "@mui/icons-material";

function Moulding_entry(props) {
  var token = window.localStorage.getItem("acessToken");
  const user = JSON.parse(window.localStorage.getItem("Name"));
  var [Date1, setDate1] = useState(new Date());
  const [Date2, setDate2] = useState(Date1.toISOString().slice(0, 10));
  const [part_dataset, setpart_dataset] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [Upholstery_, setUpholstery_] = useState(true);
  const [Cushions, setCushions] = useState(false);
  const [Buds, setBuds] = useState(false);
  const [Pleat, setPleat] = useState(false);
  const [Drape, setDrape] = useState(false);
  const [Haru, setHaru] = useState(false);
  const [Nora, setNora] = useState(false);
  const [Avro, setAvro] = useState(false);

  var length = 0;
  const [Area, setArea] = useState("");

  // State for tracking status columns
  const [statusColumnsCount, setStatusColumnsCount] = useState(0);

  const [data, setData] = useState([
    {
      Po_No: "",
      Part_No: "",
      Po_Ship_Date: Date2,
      Part_Description: "",
      Customer: "",
      Qty: "",
      Po_Date: "",
      FabricStatus: "",
      FabricStyle: "",
      FabricColor: "",
      Orientation: "",
      SalesOrderNo: "",
      BaseColor: "",
      FabricInsideBack: "",
      FabricOutsideBack: "",
      FabricSeat: "",
      Piping: "",
      FabricBack: "",
      WoodOutsideBack: "",
      UnitPrice: "",
      Comments: "",
      Wood_Seat_And_Back_Species: "",
      Wood_Seat_And_Back_Stain_Color: "",
      Seat_Pad_Fabric: "",
      Wood_Ring: "",
      // Array to store statuses for Task 1
      statuses: Array(10).fill("")
    },
    {
      Po_No: "",
      Part_No: "",
      Po_Ship_Date: Date2,
      Part_Description: "",
      Customer: "",
      Qty: "",
      Po_Date: "",
      FabricStatus: "",
      FabricStyle: "",
      FabricColor: "",
      Orientation: "",
      SalesOrderNo: "",
      BaseColor: "",
      FabricInsideBack: "",
      FabricOutsideBack: "",
      FabricSeat: "",
      Piping: "",
      FabricBack: "",
      WoodOutsideBack: "",
      UnitPrice: "",
      Comments: "",
      Wood_Seat_And_Back_Species: "",
      Wood_Seat_And_Back_Stain_Color: "",
      Seat_Pad_Fabric: "",
      Wood_Ring: "",

      statuses: Array(10).fill("")
    },
    {
      Po_No: "",
      Part_No: "",
      Po_Ship_Date: Date2,
      Part_Description: "",
      Customer: "",
      Qty: "",
      Po_Date: "",
      FabricStatus: "",
      FabricStyle: "",
      FabricColor: "",
      Orientation: "",
      SalesOrderNo: "",
      BaseColor: "",
      FabricInsideBack: "",
      FabricOutsideBack: "",
      FabricSeat: "",
      Piping: "",
      FabricBack: "",
      WoodOutsideBack: "",
      UnitPrice: "",
      Comments: "",
      Wood_Seat_And_Back_Species: "",
      Wood_Seat_And_Back_Stain_Color: "",
      Seat_Pad_Fabric: "",
      Wood_Ring: "",

      statuses: Array(10).fill("")
    },
    {
      Po_No: "",
      Part_No: "",
      Po_Ship_Date: Date2,
      Part_Description: "",
      Customer: "",
      Qty: "",
      Po_Date: "",
      FabricStatus: "",
      FabricStyle: "",
      FabricColor: "",
      Orientation: "",
      SalesOrderNo: "",
      BaseColor: "",
      FabricInsideBack: "",
      FabricOutsideBack: "",
      FabricSeat: "",
      Piping: "",
      FabricBack: "",
      WoodOutsideBack: "",
      UnitPrice: "",
      Comments: "",
      Wood_Seat_And_Back_Species: "",
      Wood_Seat_And_Back_Stain_Color: "",
      Seat_Pad_Fabric: "",
      Wood_Ring: "",

      statuses: Array(10).fill("")
    },
    {
      Po_No: "",
      Part_No: "",
      Po_Ship_Date: Date2,
      Part_Description: "",
      Customer: "",
      Qty: "",
      Po_Date: "",
      FabricStatus: "",
      FabricStyle: "",
      FabricColor: "",
      Orientation: "",
      SalesOrderNo: "",
      BaseColor: "",
      FabricInsideBack: "",
      FabricOutsideBack: "",
      FabricSeat: "",
      Piping: "",
      FabricBack: "",
      WoodOutsideBack: "",
      UnitPrice: "",
      Comments: "",
      Wood_Seat_And_Back_Species: "",
      Wood_Seat_And_Back_Stain_Color: "",
      Seat_Pad_Fabric: "",
      Wood_Ring: "",

      statuses: Array(10).fill("")
    },
  ]);

  useEffect(() => {
    var timer = setInterval(() => setDate1(new Date()), 10);
    return function cleanup() {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    Axios.get(`https://${host}/api/get/part_dataset/${token}`).then((res) => {
      setpart_dataset(res.data);
    });
  }, [token]);

  useEffect(() => {
    const newData = data.map((line) => ({ ...line, Date: Date2 }));
    setData(newData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Date2]);

  const area = () => {
    if (Area === "Upholstery") {
      setUpholstery_(true);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setNora(false);
      setAvro(false);
      setPleat(false);
    }
    if (Area === "Cushions") {
      setUpholstery_(false);
      setCushions(true);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setNora(false);
      setAvro(false);
      setPleat(false);
    }
    if (Area === "Buds") {
      setUpholstery_(false);
      setCushions(false);
      setBuds(true);
      setDrape(false);
      setHaru(false);
      setNora(false);
      setAvro(false);
      setPleat(false);
    }
    if (Area === "Drape") {
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(true);
      setHaru(false);
      setNora(false);
      setAvro(false);
      setPleat(false);
    }
    if (Area === "Haru") {
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(true);
      setNora(false);
      setAvro(false);
      setPleat(false);
    }
    if (Area === "Pleat") {
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(true);
      setAvro(false);
      setNora(false);
    }
    if (Area === "Genevieve") {
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(true);
      setAvro(false);
      setNora(false);
    }
    if (Area === "Leit") {
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(true);
      setAvro(false);
      setNora(false);
    }
    if (Area === "Stratford") {
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(true);
      setAvro(false);
      setNora(false);
    }
    if (Area === "Nora") {
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(false);
      setNora(true);
      setAvro(false);
    }
    if (Area === "Avro") {
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(false);
      setNora(false);
      setAvro(true);
    }
  };

  const submitValue = (e, index) => {
    const newData = [...data];
    newData[index].Part_No = e.target.value;
    newData[index].Customer = part_dataset.find((x) => x.Part_No === e.target.value).Customer;
    newData[index].Part_Description = part_dataset.find((x) => x.Part_No === e.target.value).Part_Description;
    setData(newData);
  };

  const addLines = () => {
    if (data.length < 15) {
      const newData = [...data];
      for (let i = 0; i < 5; i++) {
        newData.push({
          Po_No: "",
          Part_No: "",
          Po_Ship_Date: Date2,
          Part_Description: "",
          Customer: "",
          Qty: "",
          Po_Date: "",
          FabricStatus: "",
          FabricStyle: "",
          FabricColor: "",
          Orientation: "",
          SalesOrderNo: "",
          BaseColor: "",
          FabricInsideBack: "",
          FabricOutsideBack: "",
          FabricSeat: "",
          Piping: "",
          FabricBack: "",
          WoodOutsideBack: "",
          UnitPrice: "",
          Comments: "",
          Wood_Seat_And_Back_Species: "",
          Wood_Seat_And_Back_Stain_Color: "",
          Seat_Pad_Fabric: "",
          Wood_Ring: "",

          statuses: Array(10).fill("")
        });
      }
      setData(newData);
    } else {
      window.alert("Lines Reached maximum limit");
    }
  };

  // Task 1: Function to add status columns
  const addStatusColumn = () => {
    if (statusColumnsCount < 10) {
      setStatusColumnsCount(statusColumnsCount + 1);
    } else {
      window.alert("Maximum 10 status columns allowed");
    }
  };

  // Function to handle status textarea change
  // Function to handle status textarea change
  const handleStatusChange = (e, index, statusIndex) => {
    const newData = [...data];
    const text = e.target.value.trim();

    // format today's date as DD-MM-YYYY
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${today.getFullYear()}`;

    // only append date if not already present
    const finalValue = text.includes(":")
      ? text
      : `${text}:${formattedDate}`;

    newData[index].statuses[statusIndex] = finalValue;
    setData(newData);
  };


  const submitdata = () => {
    const filteredData = [];

    data.forEach((item) => {
      if ((item.Po_No || item.Part_No) && (!item.Po_Ship_Date || !item.Po_Date)) {
        // eslint-disable-next-line no-restricted-globals
        const proceed = confirm("Some fields are missing (Po Ship Date or Po Date). Do you want to continue?");
        if (!proceed) return;
      }

      if (item.Po_No && item.Part_No && item.Customer && item.Part_Description && item.Po_Ship_Date && item.Po_Date) {
        // Task 1: Combine statuses into one string with separator
        const combinedStatuses = item.statuses
          .slice(0, statusColumnsCount)
          .filter(status => status.trim() !== "")
          .join(" || ");

        const newData = [
          item.Po_No,
          item.Part_No,
          item.Po_Ship_Date,
          item.Part_Description,
          item.Customer,
          item.Qty,
          item.Po_Date,
          item.Comments,
          item.FabricStatus,
          item.FabricStyle,
          item.FabricColor,
          item.Orientation,
          item.SalesOrderNo,
          item.BaseColor,
          item.FabricInsideBack,
          item.FabricOutsideBack,
          item.FabricSeat,
          item.Piping,
          item.FabricBack,
          item.WoodOutsideBack,
          item.UnitPrice,
          item.Wood_Seat_And_Back_Species,
          item.Wood_Seat_And_Back_Stain_Color,
          item.Seat_Pad_Fabric,
          // Task 2: Add Wood Ring value
          item.Wood_Ring || "",
          // Task 1: Add combined statuses
          combinedStatuses,
          user,
        ];
        filteredData.push(newData);
      }
      length = filteredData.length;
    });

    setIsLoading(true);

    if (filteredData.length > 0) {
      setTimeout(() => {
        Axios.post(`https://${host}/api/Upholstery_entry`, { filteredData, user, token })
          .then((response) => {
            if (response.status === 200) {
              window.alert(response.data.message);
              setIsLoading(false);
              window.location.reload();
            }
          })
          .catch(() => {
            window.alert("Error Occured");
            setIsLoading(false);
          });
      }, 2000);
    } else {
      window.alert("Please fill all sections!");
      setIsLoading(false);
    }
  };

  return (
    <div className="uph-page">
      <div className="uph-toolbar">
        <div className="uph-left">
          <div className="uph-kicker">PO Entry</div>
          <h2 className="uph-title">Upholstery Entry</h2>
          <div className="uph-sub">Choose Area, fill rows, then submit.</div>
        </div>

        <div className="uph-right">
          <button onClick={addLines} className="btn btn-success uph-btn" type="button">
            Add Row
          </button>
          {/* Task 1: Add Status button */}
          <button onClick={addStatusColumn} className="btn btn-info uph-btn" type="button">
            Add Status
          </button>
          <button onClick={submitdata} className="btn btn-primary uph-btn" type="button">
            Submit
          </button>
        </div>
      </div>

      <div className="uph-filters">
        <div className="uph-selectWrap">
          <label className="uph-label">Area</label>
          <select
            className="form-control uph-select"
            id="Area"
            name="area"
            onKeyDown={area}
            onTouchMove={area}
            onSelect={area}
            onChange={(e) => setArea(e.target.value)}
            onClick={area}
          >
            <option value="Upholstery">Upholstery</option>
            <option value="Cushions">Cushions/Panels</option>
            <option value="Buds">Buds</option>
            <option value="Pleat">Pleat/Melvin</option>
            <option value="Genevieve">Genevieve</option>
            <option value="Leit">Leit</option>
            <option value="Stratford">Stratford</option>
            <option value="Drape">Drape</option>
            <option value="Haru">Haru</option>
            <option value="Nora">Nora</option>
            <option value="Avro">Avro</option>
          </select>
        </div>
      </div>

      <div className="uph-card">
        <div className="uph-tableWrap">
          <table className="table table-bordered uph-table">
            <tbody>
              <tr>
                <th>PO NO</th>
                <th>PART NO</th>
                <th>PO SHIP DATE</th>
                <th>PART DESCRIPTION</th>
                <th>CUSTOMER</th>
                <th>QTY</th>
                <th>PO DATE</th>

                {Avro || Buds || Cushions || Upholstery_ ? <th>FABRIC STATUS</th> : null}
                {Avro || Cushions || Buds || Haru ? <th>FABRIC STYLE / FABRIC BODY</th> : null}
                {Cushions || Buds || Upholstery_ ? <th>FABRIC COLOR / FABRIC TOP</th> : null}
                {Cushions ? <th>ORIENTATION</th> : null}
                {Cushions ? <th>SALES ORDER NO</th> : null}
                {Pleat || Drape || Nora ? <th>BASE COLOR</th> : null}

                {Nora ? <th>WOOD SEAT AND BACK SPECIES</th> : null}
                {Nora ? <th>WOOD SEAT AND BACK STAIN COLOUR</th> : null}
                {Nora ? <th>SEAT PAD FABRIC</th> : null}

                {Pleat || Drape ? <th>FABRIC INSIDE BACK</th> : null}
                {Pleat || Drape ? <th>FABRIC OUTSIDE BACK</th> : null}
                {Pleat || Drape ? <th>FABRIC SEAT</th> : null}
                {Pleat ? <th>PIPING</th> : null}
                {Drape ? <th>FABRIC BACK</th> : null}
                {Haru ? <th>WOOD OUTSIDE BACK</th> : null}

                {/* Task 2: Wood Ring column for Melvin/Pleat */}
                {Pleat ? <th>WOOD RING</th> : null}

                <th>UNIT PRICE</th>
                <th>COMMENTS</th>

                {/* Task 1: Status columns (up to 10) */}
                {Array.from({ length: statusColumnsCount }).map((_, index) => (
                  <th key={`status-${index}`}>STATUS {index + 1}</th>
                ))}
              </tr>

              {data.map((line, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      name="PoNo"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Po_No = e.target.value;
                        setData(newData);
                      }}
                      value={data[index].Po_No}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      name="PartNo"
                      Value={data[index].Part_No}
                      onBlur={(e) => {
                        const newData = [...data];
                        newData[index].Part_No = e.target.value;
                        setData(newData);
                        submitValue(e, index);
                      }}
                      list="PartNo"
                      style={{ resize: "none", minWidth: "300px", minHeight: "fit-content" }}
                    />
                    <div className="scrollbar">
                      <datalist id="PartNo">
                        <option></option>
                        {part_dataset.map((x) => (
                          <option key={x.Part_No}>{x.Part_No}</option>
                        ))}
                      </datalist>
                    </div>
                  </td>

                  <td>
                    <input
                      type="date"
                      className="form-control form-rounded"
                      name="PoShipDate"
                      defaultValue={Date1.toISOString().slice(0, 10)}
                      onBlur={(e) => {
                        const newData = [...data];
                        newData[index].Po_Ship_Date = e.target.value;
                        setData(newData);
                      }}
                      Value={data[index].Po_Ship_Date}
                    />
                  </td>

                  <td>
                    <textarea
                      className="form-control form-rounded"
                      name="PartDescription"
                      value={data[index].Part_Description}
                      readOnly
                      rows={2}
                      style={{ resize: "none", minWidth: "300px", minHeight: "fit-content" }}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      name="Customer"
                      value={data[index].Customer}
                      readOnly
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      name="Qty"
                      onBlur={(e) => {
                        const newData = [...data];
                        newData[index].Qty = e.target.value;
                        setData(newData);
                      }}
                      Value={data[index].Qty}
                    />
                  </td>

                  <td>
                    <input
                      type="date"
                      className="form-control form-rounded"
                      name="PoDate"
                      onBlur={(e) => {
                        const newData = [...data];
                        newData[index].Po_Date = e.target.value;
                        setData(newData);
                      }}
                      Value={data[index].Po_Date}
                    />
                  </td>

                  {Avro || Buds || Cushions || Upholstery_ ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        name="FabricStatus"
                        list="FabricStatus"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].FabricStatus = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].FabricStatus}
                        style={{ resize: "none", minWidth: "300px", minHeight: "fit-content" }}
                      />
                      <div className="scrollbar">
                        <datalist id="FabricStatus">
                          <option></option>
                          <option>COM</option>
                          <option>PUR</option>
                          <option>IN HOUSE</option>
                        </datalist>
                      </div>
                    </td>
                  ) : null}

                  {Avro || Cushions || Buds || Haru ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        name="FabricStyle"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].FabricStyle = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].FabricStyle}
                        style={{ resize: "none", minWidth: "300px", minHeight: "fit-content" }}
                      />
                    </td>
                  ) : null}

                  {Cushions || Buds || Upholstery_ ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        name="FabricColor"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].FabricColor = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].FabricColor}
                      />
                    </td>
                  ) : null}

                  {Cushions ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        name="Orientation"
                        list="orientation"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].Orientation = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].Orientation}
                      />
                      <div className="scrollbar">
                        <datalist id="orientation">
                          <option></option>
                          <option>RR</option>
                          <option>OTB</option>
                        </datalist>
                      </div>
                    </td>
                  ) : null}

                  {Cushions ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        name="SalesOrderNo"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].SalesOrderNo = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].SalesOrderNo}
                      />
                    </td>
                  ) : null}

                  {Pleat || Drape || Nora ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        name="BaseColor"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].BaseColor = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].BaseColor}
                      />
                    </td>
                  ) : null}

                  {Nora ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].Wood_Seat_And_Back_Species = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].Wood_Seat_And_Back_Species}
                      />
                    </td>
                  ) : null}

                  {Nora ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].Wood_Seat_And_Back_Stain_Color = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].Wood_Seat_And_Back_Stain_Color}
                      />
                    </td>
                  ) : null}

                  {Nora ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].Seat_Pad_Fabric = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].Seat_Pad_Fabric}
                      />
                    </td>
                  ) : null}

                  {Pleat || Drape ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].FabricInsideBack = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].FabricInsideBack}
                      />
                    </td>
                  ) : null}

                  {Pleat || Drape ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].FabricOutsideBack = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].FabricOutsideBack}
                      />
                    </td>
                  ) : null}

                  {Pleat || Drape ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].FabricSeat = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].FabricSeat}
                      />
                    </td>
                  ) : null}

                  {Pleat ? (
                    <td>
                      <input
                        type="boolean"
                        className="form-control form-rounded"
                        list="PIPING"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].Piping = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].Piping}
                      />
                      <div className="scrollbar">
                        <datalist id="PIPING">
                          <option></option>
                          <option>YES</option>
                          <option>NO</option>
                        </datalist>
                      </div>
                    </td>
                  ) : null}

                  {Drape ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].FabricBack = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].FabricBack}
                      />
                    </td>
                  ) : null}

                  {Haru ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].WoodOutsideBack = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].WoodOutsideBack}
                      />
                    </td>
                  ) : null}

                  {/* Task 2: Wood Ring input for Melvin/Pleat */}
                  {Pleat ? (
                    <td>
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => {
                          const newData = [...data];
                          newData[index].Wood_Ring = e.target.value;
                          setData(newData);
                        }}
                        Value={data[index].Wood_Ring}
                      />
                    </td>
                  ) : null}

                  {/* Task 3: Fabric Colour input for Upholstery */}


                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      name="UnitPrice"
                      onBlur={(e) => {
                        const newData = [...data];
                        newData[index].UnitPrice = e.target.value;
                        setData(newData);
                      }}
                      Value={data[index].UnitPrice}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      name="Comments"
                      onBlur={(e) => {
                        const newData = [...data];
                        newData[index].Comments = e.target.value;
                        setData(newData);
                      }}
                      Value={data[index].Comments}
                    />
                  </td>

                  {/* Task 1: Status columns rendering */}
                  {Array.from({ length: statusColumnsCount }).map((_, statusIndex) => (
                    <td key={`status-${index}-${statusIndex}`}>
                      <textarea
                        className="form-control form-rounded"
                        rows="2"
                        style={{ minHeight: "60px", minWidth: "30vh" }}
                        onBlur={(e) => handleStatusChange(e, index, statusIndex)}
                        Value={data[index].statuses[statusIndex] || ""}
                        placeholder={`Status ${statusIndex + 1}`}
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {isLoading ? (
        <div className="uph-overlay">
          <div className="uph-loadingBox">
            <div className="uph-dots">
              <span />
              <span />
              <span />
            </div>
            <div className="uph-loadingText">Submitting…</div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Moulding_entry;